import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  REGISTER_USER_REQUEST,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_RESET,
  REGISTER_USER_FAIL,
  LOAD_USER_REQUEST,
  LOAD_USER_SUCCESS,
  LOAD_USER_FAIL,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,
  FORGOT_PASSWORD_OTP_VERIFY_REQUEST,
  FORGOT_PASSWORD_OTP_VERIFY_SUCCESS,
  FORGOT_PASSWORD_OTP_VERIFY_FAIL,
  FORGOT_PASSWORD_OTP_RESEND_REQUEST,
  FORGOT_PASSWORD_OTP_RESEND_SUCCESS,
  FORGOT_PASSWORD_OTP_RESEND_FAIL,
  FORGOT_PASSWORD_RESET,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  CLEAR_ERRORS,
  NEW_REGISTER_REQUEST,
  NEW_REGISTER_SUCCESS,
  NEW_REGISTER_FAIL,
  OTP_VERIFY_REQUEST,
  OTP_VERIFY_SUCCESS,
  OTP_VERIFY_FAIL,
  OTP_RESEND_REQUEST,
  OTP_RESEND_SUCCESS,
  OTP_RESEND_FAIL,
} from "../constants/authConstants";

export const authReducer = (state = { user: {} }, action) => {
  switch (action.type) {
    case LOAD_USER_REQUEST:
    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case REGISTER_USER_REQUEST:
    case NEW_REGISTER_REQUEST:
      return {
        loading: true,
        isRegistered: false,
        errors: null,
      };

    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        isRegistered: true,
        user: action.payload,
        errors: null,
      };

    case NEW_REGISTER_SUCCESS:
      return {
        ...state,
        loading: false,
        isRegistered: true,
        pendingOtpEmail: action.payload.email, // store email for OTP step
        registrationMessage: action.payload.message,
        errors: null,
      };

    case REGISTER_USER_RESET:
      return {
        ...state,
        loading: false,
        isRegistered: false,
        errors: null,
      };

    case LOAD_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: action.payload,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        user: action.payload,
        loginErrors: null,
      };

    /*case LOGIN_USER_RESET:
            return {
                ...state,
                loading: false,
                loginErrors: null
            };*/

    case LOGOUT_SUCCESS:
      return {
        loading: false,
        isAuthenticated: false,
        user: null,
      };

    case LOGOUT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case REGISTER_USER_FAIL:
      return {
        ...state,
        loading: false,
        isRegistered: false,
        user: null,
        error: action.payload,
        errors: action.errors,
      };
    case NEW_REGISTER_FAIL:
      return {
        ...state,
        loading: false,
        isRegistered: false,
        user: null,
        registrationMessage: null,
        error: action.payload,
        errors: action.errors,
      };

    // OTP verification lifecycle
    case OTP_VERIFY_REQUEST:
      return { ...state, otpVerifying: true, otpVerified: false, otpError: null };
    case OTP_VERIFY_SUCCESS:
      return {
        ...state,
        otpVerifying: false,
        otpVerified: true,
        otpMessage: action.payload.message,
        otpError: null,
      };
    case OTP_VERIFY_FAIL:
      return {
        ...state,
        otpVerifying: false,
        otpVerified: false,
        otpError: action.payload,
        errors: action.errors,
      };

    // OTP resend lifecycle
    case OTP_RESEND_REQUEST:
      return { ...state, otpResending: true, otpResent: false, otpResendError: null };
    case OTP_RESEND_SUCCESS:
      return {
        ...state,
        otpResending: false,
        otpResent: true,
        otpResendMessage: action.payload.message,
        otpResendError: null,
      };
    case OTP_RESEND_FAIL:
      return {
        ...state,
        otpResending: false,
        otpResent: false,
        otpResendError: action.payload,
        errors: action.errors,
      };

    case LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: null,
        error: action.payload,
        loginErrors: action.errors,
      };

    case LOAD_USER_FAIL:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        user: null,
        error: action.payload,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const forgotPasswordReducer = (state = {}, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        passwordErrors: null,
      };

    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        otpSent: true,
        email: action.payload.email,
        passwordErrors: null,
      };

    case FORGOT_PASSWORD_OTP_VERIFY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FORGOT_PASSWORD_OTP_VERIFY_SUCCESS:
      return {
        ...state,
        loading: false,
        otpVerified: true,
        resetToken: action.payload.token,
        message: action.payload.message,
        error: null,
      };

    case FORGOT_PASSWORD_OTP_VERIFY_FAIL:
      return {
        ...state,
        loading: false,
        otpVerified: false,
        error: action.payload,
      };

    case FORGOT_PASSWORD_OTP_RESEND_REQUEST:
      return {
        ...state,
        resending: true,
        resendError: null,
      };

    case FORGOT_PASSWORD_OTP_RESEND_SUCCESS:
      return {
        ...state,
        resending: false,
        resendMessage: action.payload.message,
        resendError: null,
      };

    case FORGOT_PASSWORD_OTP_RESEND_FAIL:
      return {
        ...state,
        resending: false,
        resendError: action.payload,
      };

    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        success: action.payload,
        passwordErrors: null,
      };

    case FORGOT_PASSWORD_FAIL:
    case RESET_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        passwordErrors: action.errors,
      };

    case FORGOT_PASSWORD_RESET:
      return {};

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
